<template>
  <!--  待付款=1  购买成功>1  申请退款<1-->
  <div class="styleList">



    <!-- v-for="(item, index) in info" :key="index" -->
    <div class="order-list-content" >
      <!-- order_number: '256554554844',
                //  express_number:'',
                name:"基因元-婴儿基因原点备份",
                order_status:'已寄出报告',
                time:'2018-11-11  12:25:10' -->
      <div class="list-title">
        <span>订单编号：<i>{{ info.order_num }}</i></span>
        <!-- 不同的状态 -->
        <!--        <a class="order-home-title" v-show="type == 'order-home'">-->
        <a class="order-home-title" style="display: none">
          <span class="colorSuccess">

             {{ info.order_status }}

          </span>
        </a>

        <!--
                <a class="order-home-title add1" v-show="type  == 'allOrder'">
                  <span :class="info.order_status > 1 ? 'colorSuccess' : 'colorStatus'">
                    {{
                    info.order_status > 1 ? '购买成功' : (info.order_status =1 ?  '待付款' :'申请退款')
                    }}
                    {{info.order_status}}
                  </span>
                </a>
                -->

        <!-- <span class="colorSuccess">购买成功</span>
                        <span class="colorStatus">购买失败</span> -->
        <!-- <span class="colorSuccess">已付款</span>
                        <span class="colorSuccess">已寄出采样工具</span>
                        <span class="colorSuccess">已寄回样本</span>
                        <span class="colorSuccess">已收样</span>  -->
        <!-- <span class="colorSuccess">待付款</span> -->
      </div>

      <div class="list-content">
        <a href="javascript:;"><img v-lazy="info.home_page" alt=""></a>
        <span class="content-box">
					<!-- 全部订单 -->
					<div class="allOrder" v-show="type == 'allOrder'">
						<i class="allorder1" style='font-size: 0.3rem'>{{ info.name }}</i>
            <i class="allorder1" style='font-size: 0.3rem;position: absolute;right: 0px;top: 0.1rem;'>数量:1</i><br/>
						<i class="allorder1" style='font-size: 0.3rem'>收件人:{{ info.consignee_name }}</i><br/>
						<i class="allorder1" style='font-size: 0.3rem'>时间:{{ info.time }}</i><br/>
						<i>{{ info.order_username }}</i>
					</div>
          <!-- 绑定样式 -->
					<div class="style-content" v-show="type == 'style' || type == 'wait'">
						<span>
							<i class="style-name">{{ info.name }}</i><br>
							<i class="style-name">收件人:{{ info.consignee_name }}</i><br>
							<i class="style-count">被采集人姓名:{{ info.gather_name }}</i><br>
							<i class="style-count">数量:1</i> /
							<i class="style-count">时间:{{ info.time }}</i>
						</span>
					</div>

          <!-- 我的检测 -->
					<div class="myCheck" v-show="type == 'check'">
						<span>{{ info.name }}</span><br>
						<span>时间：{{ info.time }}</span>
						<span class="check-count">x 1</span>
					</div>
          <!-- 我的-订单中心 -->
					<div class="orderCenter-home" v-show="type == 'order-home'">
						<span>
              <i>{{ info.name }}</i><br>
              <i>收件人：</i><i>{{ info.consignee_name }}</i><br>
              <i>数量：</i><i>1</i><br>
              <i>时间：</i><i>{{ info.time }}</i>
            </span>
						<span class="orderHome-count">x 1</span>
					</div>
				</span>
        <!-- 会有变动的地方 -->
        <!-- <span>样式绑定</span> -->

        <el-button type="primary"
                   size="mini" v-show="type == 'wait'" class="style-btn" @click.stop.prevent="bind(type,info)">填写快递单号
        </el-button>


        <!-- 我的检测 -->

        <el-button type="primary" size="mini" v-show="type == 'style'" class="style-btn"
                   @click.prevent="bindStyle(type,info)">绑定样本编号
        </el-button>

        <!-- <span>已收样</span> -->
      </div>

      <!-- 另一种可能 -->
      <div class="list-title list-footer" v-show="type != 'style' && type != 'allOrder' && type != 'wait'">
        <!--      <p class="list-title list-footer">-->

        <span v-show="type == 'check'">进度：<i>{{ info.order_status }}</i></span>

        <div style="display: none">
          <!-- 快递单号-->
          <b>{{ info.express_number }}</b>/

          <!--            样本编号-->
          <b>{{ info.sample_number }}</b>/

          <!--            1 待付款,2 已付款,3已寄出工具-->
          <b>{{ info.order_status }}</b>/

          <!--            分类  1 检测类,2 保存类,3 保管类,4 积分订单 5:检测卡-->
          <b>{{ info.classify }}</b>
        </div>

        <!--        <a class="order-home-money" v-show="type == 'order-home'">-->
        <a class="order-home-money">
          <span>
            金额：<i>￥{{ info.services * 1 > 0 ? info.money * 1 + info.services * 1 : info.money * 1 }}</i>
          </span>


          <!--                          v-if="info.express_number != null && info.sample_number != null"-->
          <span @click.prevent="payBtn(type,info,'')"
                v-if="info.express_number != null && info.sample_number != null  ">
            {{ info.order_status == '待付款' ? '去支付' : info.order_status }}
            <!--            {{ info.order_status > 1 ? '购买成功' : (info.order_status =1 ?  '待付款' :'申请退款')}}-->
            <!--            {{info.order_status}}-->
          </span>

          <span @click.prevent="payBtn(type,info,text)"
                v-if="info.sample_number == null && info.express_number != null&&info.classify!=5">{{ text }}</span>

          <span @click.prevent="payBtn(type,info,text2)"
                v-if="info.express_number == null && info.sample_number != null">{{ text2 }}</span>

          <span @click.prevent="payBtn(type,info,text)"
                v-if="info.express_number == null && info.sample_number == null && info.order_status != '待付款'&&info.classify!=5">{{ text }}</span>
        </a>

      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'styleList',

  props: {
    info: Object,
    type: String
  },
  data() {
    return {

      classify: '',
      text: '绑定样本编号',
      text2: '绑定快递单号',

    }
  },
  created() {

  },
  methods: {

    // 填写快递单号
    bind(type, info) {

      this.classify = info.classify
      let binds = {
        types: type,
        expre: info
      }
      this.$emit('bindtype', binds)
      // this.tonc()
    },

    tonc(type) {
      let that = this

      if (that.classify == 1 || that.classify == 2) {

        that.$http.api.toNc({
          order_id: that.info.order_id
        }).then((res) => {

        })

      } else if (that.classify == 3) {

        that.$http.api.toCareNc({
          order_id: that.info.order_id
        }).then((res) => {

        })
      }

    },


    // 绑定样本编号
    bindStyle(type, info) {
      let infos = {
        types: type,
        binds: info
      }
      this.$emit('bindsty', infos)
    },

    payBtn(type, status, text) {
      console.log(text)
      let data = {
        types: type,
        text: text,
        order_info: status
      }

      this.$emit('bindpay', data)

    }
  }
}
</script>
<style lang="less" scoped>
.allOrder1 {
  font-size: 0.3rem !important;
  color: #666666 !important;
  line-height: 0.2rem !important;
}

.order-list-content {
  width: 100%;
  min-height: 110px;
  margin-bottom: 3px;

  .list-content {
    width: 100%;
    background: #fff;
    font-size: 14px;
    color: #333333;

  }

  .list-title {
    height: 36px;
    line-height: 36px;
    background: #FBFBFB;
    border: 1px solid #E6E6E6;
    border-left: none;
    border-right: none;
    position: relative;

    i {
      color: #60B0E3;
    }

    span:nth-child(1) {
      // margin-left: 10px;
      position: absolute;
      left: 10px;
      height: 34px;
      line-height: 34px;
      font-size: 14px;
      top: 0;
    }

    .colorSuccess {
      height: 34px;
      line-height: 34px;
      position: absolute;
      right: 10px;
      color: #60B0E3;
    }

    .colorStatus {
      height: 34px;
      line-height: 34px;
      position: absolute;
      right: 10px;
      color: #CCCCCC;
    }

    .order-home-title {
      // width: 50%;
      position: absolute;
      top: 0;
      right: 10px;

      span {
        position: static;
        font-size: 10px;
      }
    }
  }

  .list-footer {
    background: #fff;

    .order-home-money {
      position: absolute;
      width: 100%;
      height: 100%;
      overflow: hidden;

      span {
        &:nth-child(2) {
          position: absolute;
          right: 10px;
          padding: 6px 15px;
          background: #60B0E3;
          font-size: 10px;
          color: #fff;
          border-radius: 10px;
          box-sizing: border-box;
          line-height: 10px;
          margin: 5px 0;
        }
      }
    }
  }

  .list-content {
    width: 100%;
    height: 88px;
    padding-top: 10px;
    padding-left: 10px;
    position: relative;

    a {
      width: 100px;
      height: 50px;
      // overflow: hidden;
      display: block;
      // margin-left: 10px;
      // box-sizing: border-box;
      position: absolute;
      left: 10px;

      img {
        width: 100px;
        height: 50px;
        //   margin-top: 10px;
      }
    }

    .content-box {
      width: 60%;
      //  display: inline;
      position: absolute;
      left: 120px;
      text-align: left;

      span {
        width: 100%;
        height: 20px;
        //   line-height: 20px;
        display: inline-block;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      span:nth-child(1) {
        font-size: 16px;
        color: rgba(102, 102, 102, 1);
      }

      span:nth-child(2) {
        font-size: 10px;
        color: rgba(102, 102, 102, 1);
      }

      .myCheck {
        padding-top: 2px;
        position: relative;

        span {
          font-size: 10px;
          line-height: 20px;
          color: rgba(102, 102, 102, 1);
        }

        .check-count {
          position: absolute;
          bottom: 3px;
        }
      }

      .orderCenter-home {
        position: relative;
        top: -5px;

        span {
          height: auto;
          font-size: 10px;
          color: rgba(102, 102, 102, 1);
        }

        .orderHome-count {
          position: absolute;
          bottom: 20px;
        }
      }

      .style-content {
        span {
          height: auto;
          font-size: 0.25rem;
          color: #666666;
        }

        .style-name {
          font-size: 0.28rem;
          color: #666666;
        }

        .style-count {
          color: #999;
        }
      }

      .allOrder {
        span {
          // height: auto;
          font-size: 10px;
          color: #666666;
        }

        .allorder {
          font-size: 12px;
        }
      }

    }

    .style-btn {
      position: absolute;
      top: 0.8rem;
      right: 0.2rem;
      z-index: 10;
      font-size: 0.28rem;
      padding: 0.2rem;
    }

    .style-btn-status {
      width: auto;
      font-size: 10px;
      position: absolute;
      bottom: 13px;
      right: 10px;
      background: #fff;
      border-radius: 8px;
      padding: 4px 6px;
      box-sizing: border-box;
      color: rgba(96, 176, 227, 1);
      border: 1px solid rgba(96, 176, 227, 1);
      border-radius: 4px;
    }
  }
}
</style>
